export type RgbByte = { r: number; g: number; b: number };

export function hexRgb(hex: string): RgbByte {
    const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
    if (!m) return { r: 0xd7, g: 0x41, b: 0x41 };
    const n = parseInt(m[1], 16);
    return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

export function rgbToHue(r: number, g: number, b: number): number {
    const rn = r / 255;
    const gn = g / 255;
    const bn = b / 255;
    const max = Math.max(rn, gn, bn);
    const min = Math.min(rn, gn, bn);
    const d = max - min;
    if (d === 0) return 0;
    let h = 0;
    if (max === rn) h = ((gn - bn) / d) % 6;
    else if (max === gn) h = (bn - rn) / d + 2;
    else h = (rn - gn) / d + 4;
    h *= 60;
    if (h < 0) h += 360;
    return h;
}

export function normalizeHueDelta(delta: number): number {
    let d = delta;
    while (d > 180) d -= 360;
    while (d < -180) d += 360;
    return Math.round(d);
}

export function normRgb01(hex: string): [number, number, number] {
    const { r, g, b } = hexRgb(hex);
    return [r / 255, g / 255, b / 255];
}

export function mixTowardBlackHex(hex: string, t: number): string {
    const { r, g, b } = hexRgb(hex);
    const blend = (c: number) => Math.round(Math.max(0, Math.min(255, c * (1 - t))));
    return `#${[blend(r), blend(g), blend(b)].map(x => x.toString(16).padStart(2, '0')).join('')}`;
}
